import React, { useEffect } from "react";
import logo from "../assets/images/logo.png";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import fbicon from '../assets/images/home/fb.svg';
import twiitericon from '../assets/images/home/twitter.svg';
import instaicon from '../assets/images/home/insta.svg';
import getitonimg1 from "../assets/images/home/getitonimg1.webp";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
const goToAboutSection = (name) => {
    navigate("/#"+name);
  };
  return (
    <section>
    <div className="footermaindiv">
      <div className="container">
        <img src={logo} className="footerlogo" />
        <div className="footercontactrow">
          <Link className="footercontactrow1" to={"mailto:info@manasthal.com"}>
            <FontAwesomeIcon icon={faEnvelope} className="footericon" />
            <p className="footeremail">info@manasthal.com</p>
          </Link>
          <Link className="footercontactrow1" to={"tel:+919959094566"}>
            <FontAwesomeIcon icon={faPhone} className="footericon" />
            <p className="footeremail">+91 9959094566</p>
          </Link>
        </div>
        <div className="footermenurow">
          <div className="footermenu-nav">
            <nav className="navbar navbar-expand-lg  custom-nav ">
              <ul class="navbar-nav">
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("Home")}}>Home</p>
                </li>
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("About")}}>About</p>
                </li>
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("Features")}}>Features</p>
                </li>
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("Howitworks")}}>How it works</p>
                </li>
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("Benefits")}}>Benefits</p>
                </li>
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("Testimonials")}}>Testimonials</p>
                </li>
                <li className={"nav-item"}>
                  <p onClick={() => {goToAboutSection("FAQS")}}>FAQS</p>
                </li>
              </ul>
            </nav>
          </div>
          <div className="footerjoinusdiv">
            <p className="joinus-text">Join Us</p>
            <div className="footer-sociodiv">
              <Link className="header-fb-icon" to={"https://www.facebook.com/profile.php?id=61579143035601"} target="_blank">
                <img src={fbicon} className="fbicon" />
              </Link>
              <Link className="header-fb-icon" to={"https://x.com/team_mansthal"} target="_blank">
                <img src={twiitericon} className="fbicon" />
              </Link>
              <Link className="header-fb-icon" to={"https://www.instagram.com/team.mansthal/"} target="_blank">
                <img src={instaicon} className="fbicon" />
              </Link>
            </div>
          </div>
          <div className="footergetitondiv">
              <img src={getitonimg1} className="footergetitonimg" />
          </div>
        </div>
        <hr className="footer-hr" />
        <div className="copyright-row">
          <p className="copyrighttext">© Mansthal 2025, All Right Reserved.</p>
          <div className="policyrow">
              <Link to={"/terms-conditions"} className="policytext">Terms & Conditions</Link>
              <Link to={"/privacy-policy"} className="policytext">Privacy Policy</Link>
              <Link to={"/disclaimer"} className="policytext">Disclaimer</Link>
              <Link to={"/child-safety"} className="policytext">Child Safety</Link>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Footer;
